<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation 
      @submit.prevent="addOrder">
           <div class="registration-btn bottom-btn">
            <v-btn
              width="146"
              class="mr-2"
              outlined
              color="primary"
              :to="{ name: 'SingleProduct' }"
              >{{$t('cancel')}}</v-btn
            >
            <v-btn width="146" type="submit" color="primary">{{$t('submit')}}</v-btn>
          </div>
        <div class="registration-section">
          <v-card class="px-5 py-5 mt-5">
            <div class="main-register">
            <div class="registration-heading">
              <h2>{{$t('organizationNtrInfo.createAOrder')}}</h2>
            </div>
          </div>
            <div class="animal-from">
              <v-row class="pa-5">
                <v-col cols="12"></v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{$t('farm.farmID')}} <span>*</span></label>
                    </div>
                    <v-text-field
                      v-model="orderDetails.farmNumber"
                      disabled
                      outlined
                      dense
                      :placeholder="$t('farm.farmID')"
                      :error-messages="errors.farmNumber"
                      :rules="orderRules.farmNumber"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{$t('organizationNtrInfo.transactionID')}} <span>*</span></label>
                    </div>
                    <v-text-field
                      v-model="orderDetails.transactionId"
                      outlined
                      dense
                      :placeholder="$t('organizationNtrInfo.transactionID')"
                      :error-messages="errors.transactionId"
                      :rules="orderRules.transactionId"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label>{{$t('organizationNtrInfo.transactionDate')}} <span>*</span></label>
                    </div>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      dense
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="orderDetails.transactionDate"
                          :placeholder="$t('organizationNtrInfo.chooseTheDate')"
                          append-icon="mdi-calendar"
                          outlined
                          readonly
                          dense
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors.transactionDate"
                          :rules="orderRules.transactionDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="orderDetails.transactionDate"
                        no-title
                        scrollabel
                         :min="new Date().toISOString().substr(0, 10)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu=false">
                          {{$t('cancel')}}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(orderDetails.transactionDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col lg="3" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{$t('farm.productName')}} <span>*</span></label>
                    </div>
                    <v-text-field
                      v-model="orderDetails.productNumber"
                      :placeholder="$t('farm.productName')"
                      outlined
                      dense
                      disabled
                      :error-messages="errors.productNumber"
                      :rules="orderRules.productNumber"
                    ></v-text-field>
                  </div>
                </v-col>
                 <v-col lg="3" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('farm.productCategory')}} <span>*</span></label>
                    <v-select
                      :items="category"
                      v-model="orderDetails.productCategoriesOptId"
                      :placeholder="$t('organizationNtrInfo.selectCategory')"
                      item-value="id"
                      item-text="name"
                      outlined
                      dense
                      :rules="productRules.productCategory"
                    ></v-select>
                  </div>
                </v-col>
                <v-col lg="6" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('organizationNtrInfo.volumeOfProduct')}} <span>*</span></label>
                    <v-layout row>
                      <v-col lg="6" md="4" sm="4" xs="6">
                        <v-text-field
                          type="number"
                          :placeholder="$t('organizationNtrInfo.productQuantity')"
                          outlined
                          dense
                          v-model="orderDetails.productQty"
                          :error-messages="errors.productQty"
                          :rules="orderRules.productQty"
                        ></v-text-field>
                      </v-col>
                      <v-col lg="6" md="4" sm="4" xs="6">
                        <v-select
                          :items="perUni"
                          :placeholder="$t('organizationNtrInfo.selectUnit')"
                          outlined
                          dense
                          v-model="orderDetails.productQtyUom"
                          :error-messages="errors.productQtyUom"
                          :rules="orderRules.productQtyUom"
                        ></v-select>
                      </v-col>
                    </v-layout>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('organizationNtrInfo.productRecipientId')}} <span>*</span></label>
                    <v-text-field
                      v-model="orderDetails.recipientId"
                      :placeholder="$t('organizationNtrInfo.productRecipientId')"
                      outlined
                      dense
                      :error-messages="errors.recipientId"
                      :rules="orderRules.recipientId"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text"
                      >{{$t('organizationNtrInfo.productRecipientName')}} <span>*</span></label
                    >
                    <v-text-field
                      v-model="orderDetails.recipientName"
                      :placeholder="$t('organizationNtrInfo.productRecipientName')"
                      outlined
                      dense
                      :error-messages="errors.recipientName"
                      :rules="orderRules.recipientName"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text"
                      >{{$t('organizationNtrInfo.productRecipientType')}} <span>*</span></label
                    >
                    <v-text-field
                      v-model="orderDetails.recipientType"
                      :placeholder="$t('organizationNtrInfo.productRecipientType')"
                      outlined
                      dense
                      :error-messages="errors.recipientType"
                      :rules="orderRules.recipientType"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('organizationNtrInfo.totalPrice')}} <span>*</span></label>
                    <v-text-field
                      v-model="orderDetails.totalPrice"
                      :placeholder="$t('organizationNtrInfo.totalPrice')"
                      outlined
                      dense
                      :error-messages="errors.totalPrice"
                      :rules="orderRules.totalPrice"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('organizationNtrInfo.currency')}} <span>*</span></label>
                    <v-select
                      :items="currency"
                      v-model="orderDetails.currency"
                      :placeholder="$t('organizationNtrInfo.selectCurrency')"
                      outlined
                      dense
                      :rules="orderRules.currency"
                    ></v-select>
                  </div>
                </v-col>
                <v-col lg="8" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('organizationNtrInfo.address')}} <span>*</span></label>
                    <v-text-field
                      v-model="orderDetails.address"
                      :placeholder="$t('organizationNtrInfo.enterAddress')"
                      outlined
                      dense
                      :rules="orderRules.address"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="12" md="4" sm="4" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('organizationNtrInfo.attachments')}}</label>
                    <v-card-text class="black--text">
                      <div class="form">
                        <div v-if="!orderDetails.attachments">
                          <div
                            :class="[
                              'dropZone',
                              dragging ? 'dropZone-over' : '',
                            ]"
                            @dragenter="dragging = true"
                            @dragleave="dragging = false"
                          >
                            <div class="dropZone-info" @drag="onChange">
                              <span
                                class="fa fa-cloud-upload dropZone-title"
                              ></span>
                              <span class="dropZone-title">
                                <v-icon x-large color="primary"
                                  >mdi-tray-arrow-up</v-icon
                                >
                              </span>
                              <div class="d-flex-start">
                                <div class="primary--text">{{$t('organizationNtrInfo.chooseFile')}}</div>
                              </div>
                              <div class="dropZone-upload-limit-info">
                                <div>
                                  {{$t('dropYourFileHere')}}
                                </div>
                              </div>
                            </div>
                            <input type="file" @change="onChange" />
                          </div>
                        </div>
                        <div v-else class="dropZone-uploaded">
                          <div class="dropZone-uploaded-info">
                            <v-btn
                              class="ma-2 white--text"
                              @click="removeFile"
                              color="primary"
                              outlined
                            >
                              {{$t('organizationNtrInfo.removeFile')}}
                              <v-icon right dark> mdi-trash-can </v-icon>
                            </v-btn>
                          </div>
                        </div>

                        <div
                          v-if="orderDetails.attachments"
                          class="uploadedFile-info"
                        >
                          <div>{{ orderDetails.attachments.name }}</div>
                        </div>
                      </div>
                    </v-card-text>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </div>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import Breadcrumb from "@/components/core/Breadcrumb";
import loadingMixin from "@/mixins/LoadingMixin";
import NtrService from "@/_services/NtrService";
import { orderRules } from "@/validations/OrderFormRules.js";
import { productRules } from "@/validations/ProductRules.js";
import GeneralService from "@/_services/GeneralService";
export default {
  components: {
    breadcrumb: Breadcrumb,
  },
  mounted() {
    this.loadOptions();
  },
  data() {
    return {
      orderId: "",
      menu:false,
      error: false,
      valid:true,
      orderRules,
      productRules,
      category:[],
      errors: {
        farmNumber: "",
        transactionId: "",
        transactionDate: "",
        productNumber: "",
        productQty: "",
        productQtyUom: "",
        recipientId: "",
        recipientName: "",
        recipientType: "",
        totalPrice: "",
      },
      orderDetails: {
        farmNumber: this.$route.params.farmId,
        productNumber: this.$route.params.productId,
        attachments: "",
      },
      perUni: ["kg"],
      currency: ["INR", "USD"],
      dragging: false,
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('organizationNTR'),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "ProductList" },
        },
        {
          text: this.$t('organizationNtrInfo.singleProduct'),
          disabled: false,
          link: true,
          exact: true,
          to: {
            name: "SingleProduct",
            params: {
              farmId: this.$route.params.farmId,
              productId: this.$route.params.productId,
            },
          },
        },
        {
          text: this.$t('organizationNtrInfo.createAOrder'),
          disabled: true,
          href: "#",
        },
      ],
    };
  },
  methods: {
    loadOptions() {
      const options = {
        options: ["product-categories"],
      };
      GeneralService.getDropdownData(options).then((data) => {
        this.category = data.data["product-categories"];
        console.log(this.category);
      });
    },
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
    },
    createFile(file) {
      this.orderDetails.attachments = file;
      this.dragging = false;
    },
    removeFile() {
      this.orderDetails.attachments = "";
    },
    // emptyErrors() {
    //   this.error = false;
    //   this.errors.farmNumber = "";
    //   this.errors.productNumber = "";
    //   this.errors.productQty = "";
    //   this.errors.productQtyUom = "";
    //   this.errors.recipientId = "";
    //   this.errors.transactionId = "";
    //   this.errors.transactionDate = "";
    //   this.errors.recipientName = "";
    //   this.errors.recipientType = "";
    //   this.errors.totalPrice = "";
    // },
    addOrder() {
      // this.emptyErrors();
      // if (!this.orderDetails.farmNumber) {
      //   this.errors.farmNumber = "Farm Number is required";
      //   this.error = true;
      // }
      // if (!this.orderDetails.productNumber) {
      //   this.errors.productNumber = "Product Name is required";
      //   this.error = true;
      // }
      // if (!this.orderDetails.transactionId) {
      //   this.errors.transactionId = "Transaction Id is required";
      //   this.error = true;
      // }
      // if (!this.orderDetails.transactionDate) {
      //   this.errors.transactionDate = "Transaction Date is required";
      //   this.error = true;
      // }
      // if (!this.orderDetails.productQty) {
      //   this.errors.productQty = "Enter Product Quantity";
      //   this.error = true;
      // }
      // if (!this.orderDetails.productQtyUom) {
      //   this.errors.productQtyUom = "Please Select Unit";
      //   this.error = true;
      // }
      // if (!this.orderDetails.recipientId) {
      //   this.errors.recipientId = "Recipient Id is required";
      //   this.error = true;
      // }
      // if (!this.orderDetails.recipientName) {
      //   this.errors.recipientName = "Recipient Name is required";
      //   this.error = true;
      // }
      // if (!this.orderDetails.recipientType) {
      //   this.errors.recipientType = "Recipient Type is required";
      //   this.error = true;
      // }
      // if (!this.orderDetails.totalPrice) {
      //   this.errors.totalPrice = "Please Enter Total Price";
      //   this.error = true;
      // }
      // if (this.error) return;
       if (!this.$refs.form.validate()) return;
      this.startLoading();
      // this.orderDetails.farmNumber=this.$route.params.farmId
      console.log("res", this.orderDetails);
       if (!this.$refs.form.validate()) return;
      let formData = new FormData();
      for (var key in this.orderDetails) {
        formData.append(key, this.orderDetails[key]);
      }
      NtrService.addOrder(formData)
        .then(async (res) => {
          this.orderId = res.data.order.orderNumber;
          if (res.success) {
            await this.$notify({
              title: this.$t('inseminatorStatisticsInfo.orderPlaced'),
              text: res.message,
              type: "success",
            });
            // await this.$store.dispatch("loadOrder", res.data.order);
            this.$router.push({
              name: "OrderDetails",
              params: { orderId: this.orderId },
            });
          } else {
            this.$notify({
              title: this.$t('inseminatorStatisticsInfo.orderNotPlaced'),
              text: res.message,
              type: "error",
            });
          }
          this.stopLoading();
        })
        .catch((error) => {
          if (error.status == 422) {
            error.data.message.errors.forEach((err) => {
              console.log(err.param + " -- " + err.msg);
              this.errors[err.param] = err.msg;
            });
            console.log(this.errors);
          }
          this.stopLoading();
        });
      // this.orderDetails = {};
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss">
.registration-section .main-register {
  display: flex;
  justify-content: space-between;
}
.registration-heading {
  display: flex;
  align-items: center;
}
.registration-section .registration-heading h2 {
  /* color:#6A7784; */
  /* font-size: 20px; */
  font-family: Poppins-Medium;
}
.registration-section .registration-heading span {
  width: 1px;
  height: 30px;
  /* background: #6A7784; */
  margin: 0px 15px;
}
.registration-section .registration-heading p {
  /* color: #97A8B8; */
  font-size: 20px;
  font-family: Poppins-Medium;
}
.registration-btn {
  display: flex;
  align-items: center;
}
.registration-btn.bottom-btn {
  // margin: 10px px 0px 0px;
  justify-content: flex-end;
  padding: 24px 15px;
  // border-top: 1px solid #dae1ec;
  width: 100%;
}
.animal-from.margin-cell-3 {
  margin-top: 20px;
}
.animal-from {
  display: inline;
}
.animal-from label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.animal-from .form-control {
  display: block;
  width: 100%;
  height: 50px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.animal-from .form-control:focus-visible,
.form-control-2:focus-visible {
  outline: none;
}
.animal-from .form-control::placeholder {
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.form-group {
  margin-top: -20px;
}
.animal-from .form-group span {
  color: red;
}
.dropZone {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px dashed #97a8b8;
}

.dropZone:hover {
  border: 2px solid $primary-color;
}

.dropZone:hover .dropZone-title {
  color: $primary-color;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px solid $primary-color;
  // border-radius: 10px;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}
.removeFile {
  width: 200px;
}
</style>
